import {
  AppFooter_v2 as AppFooter,
  Button_v2 as Button,
  Container_v2 as Container,
  Picture,
  Typography,
  TypographyVariantsEnum,
} from '@mindly/ui-components';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { PrivateRoutes } from '../../routes/navigation';

type SuccessTrialSessionWidgetProps = {
  history: RouteComponentProps['history'];
};

export function SuccessTrialSessionWidget({ history }: SuccessTrialSessionWidgetProps) {
  const { t } = useTranslation('booking');

  return (
    <>
      <Container>
        <div className="h-full flex items-center">
          <div className="flex flex-col justify-center items-center">
            <Picture
              width={120}
              height={120}
              srcType="image/png"
              src={{
                src: '/assets/icon-check.webp',
              }}
            />
            <Typography variant={TypographyVariantsEnum.Title28Semi} align="center">
              {t('success_trial_booking.title')}
            </Typography>
            <Typography variant={TypographyVariantsEnum.Text14Regular} align="center" className="mt-2" opacity={50}>
              {t('success_trial_booking.subtitle')}
            </Typography>
            <span className="my-8 w-full border border-solid !border-typography-typography-primary/10" />
            <ul>
              <li className="flex items-start">
                <Typography className="mr-6" variant={TypographyVariantsEnum.Title24Semi}>
                  🎧
                </Typography>
                <Typography variant={TypographyVariantsEnum.Text14Regular} align="left">
                  {t('success_trial_booking.text.0')}
                </Typography>
              </li>
              <li className="flex mt-5">
                <Typography className="mr-6" variant={TypographyVariantsEnum.Title24Semi}>
                  🔕
                </Typography>
                <Typography variant={TypographyVariantsEnum.Text14Regular} align="left">
                  {t('success_trial_booking.text.1')}
                </Typography>
              </li>
              <li className="flex mt-5">
                <Typography className="mr-6" variant={TypographyVariantsEnum.Title24Semi}>
                  ☂️
                </Typography>
                <Typography variant={TypographyVariantsEnum.Text14Regular} align="left">
                  {t('success_trial_booking.text.2')}
                </Typography>
              </li>
            </ul>
          </div>
        </div>
      </Container>
      <AppFooter>
        <Button size="large" fullWidth onClick={() => history.push(PrivateRoutes.CONSULTATION)}>
          {t('success_trial_booking.done_button')}
        </Button>
      </AppFooter>
    </>
  );
}
